import { useState } from "react";
import { faqList } from "@/mocks/editorial";
import SectionHeader from "./SectionHeader";

const schema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqList.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50 py-12 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeader
              kicker="常见问题 · FAQ"
              title="关于热点观察，你可能想问"
              desc="下面是读者最常问的几个问题。若仍有疑问，欢迎通过页面底部方式联系我们。"
            />
            <div className="mt-8 hidden rounded-2xl border border-accent-200 bg-accent-100/70 p-6 lg:block">
              <p className="flex items-center gap-2 font-medium text-accent-900">
                <i className="ri-chat-3-line text-lg"></i>
                想讨论某场风波？
              </p>
              <p className="mt-2 text-sm leading-relaxed text-accent-900/80">
                带上你看到的线索与困惑，我们愿意一起把它拆开看，而不是一起上头。
              </p>
              <a
                href="#contact"
                className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-800 underline-offset-4 hover:underline"
              >
                联系我们
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-3">
              {faqList.map((f, i) => {
                const open = openIndex === i;
                return (
                  <div
                    key={f.q}
                    className={`overflow-hidden rounded-2xl border transition-colors ${
                      open
                        ? "border-primary-200 bg-primary-50/50"
                        : "border-background-200 bg-background-100/50"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? null : i)}
                      aria-expanded={open}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-medium text-foreground-900 md:text-[15px]">
                        {f.q}
                      </span>
                      <span
                        className={`grid h-7 w-7 shrink-0 place-items-center rounded-full text-base transition-transform ${
                          open
                            ? "rotate-180 bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-700"
                        }`}
                      >
                        <i className="ri-arrow-down-s-line"></i>
                      </span>
                    </button>
                    {open && (
                      <p className="border-t border-background-200/70 px-5 py-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
                        {f.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}